export default __webpack_public_path__ + "static/media/genealogy-icon.56b2f755.svg";